import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import StudentProfileDetails from './routes/Details';
import StudentProfileAttendance from './routes/Attendance';
import StudentProfileDocuments from './routes/Documents';
import StudentProfileGatePass from './routes/GatePass';
import StudentProfileExams from './routes/Exams';
import StudentProfileComplaints from './routes/Complaints';

const StudentProfileTemplateLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StudentProfile' */ './components/StudentProfileTemplate'
		)
);

export default () => ({
	path: 'student-profile/:id',
	element: <AsyncLoading component={<StudentProfileTemplateLazy />} />,
	children: [
		StudentProfileDetails(),
		StudentProfileAttendance(),
		StudentProfileDocuments(),
		StudentProfileGatePass(),
		StudentProfileExams(),
		StudentProfileComplaints(),
	],
});
